import { Theme } from "@mui/material";
import { ComponentsProps, Components } from "@mui/material/styles";

import { getTestAutomationProps } from "~/utils/testUtils";

export const getMuiGridComponent = (theme: Theme): Components["MuiGrid"] => ({
  defaultProps: getTestAutomationProps("grid") as ComponentsProps["MuiGrid"],
  styleOverrides: {},
});
